const banana = {
  menuItem: {
    backgroundColor: {
      r: "255",
      g: "255",
      b: "255",
      a: "0",
    },
    backgroundColorHover: {
      r: "248",
      g: "231",
      b: "28",
      a: "1",
    },
    color: {
      r: "0",
      g: "0",
      b: "0",
      a: "1",
    },
    colorHover: {
      r: "0",
      g: "0",
      b: "0",
      a: "1",
    },
    iconColor: {
      r: "0",
      g: "0",
      b: "0",
      a: "1",
    },
    iconColorHover: {
      r: "0",
      g: "0",
      b: "0",
      a: "1",
    },
  },
  sidePanel: {
    backgroundColor: {
      r: "219",
      g: "213",
      b: "100",
      a: "0.52",
    },
  },
  customiseLogo: {
    backgroundColor: {
      r: "248",
      g: "231",
      b: "28",
      a: "1",
    },
  },
  previewPanel: {
    backgroundColor: {
      r: "216",
      g: "208",
      b: "88",
      a: "0.19",
    },
  },
  previewPanelHeader: {
    backgroundColor: {
      r: "233",
      g: "208",
      b: "58",
      a: "0.29",
    },
  },
  colors: {
    bg: {
      normal: [
        {
          "bg-primary": {
            r: "126",
            g: "211",
            b: "33",
            a: "1",
          },
        },
        {
          "bg-secondary": {
            r: "248",
            g: "231",
            b: "28",
            a: "1",
          },
        },
        {
          "bg-sidebar": "#172933",
        },
        {
          "bg-background-light": "#EEF2F7",
        },
        {
          "bg-surface-01": "#f4f4f4",
        },
        {
          "bg-surface-02": "#F2F2F2",
        },
        {
          "bg-surface-03": "#f4f4f5",
        },
        {
          "bg-border-color": "#EBECED",
        },
        {
          "bg-text-secondary": "#9A9A9A",
        },
        {
          "bg-text-muted": "#929292",
        },
        {
          "bg-text-disabled": "#8B8A8B",
        },
        {
          "bg-danger-light": {
            r: "155",
            g: "245",
            b: "35",
            a: "0.27",
          },
        },
        {
          "bg-table-header-bg": "#0A192F",
        },
        {
          "bg-table-header-text": "#ffffff",
        },
        {
          "bg-table-body-bg": "#ffffff",
        },
      ],
      hover: [
        {
          "hover:bg-primary": {
            r: "126",
            g: "211",
            b: "33",
            a: "1",
          },
        },
        {
          "hover:bg-secondary": {
            r: "248",
            g: "231",
            b: "28",
            a: "1",
          },
        },
        {
          "hover:bg-sidebar": "#172933",
        },
        {
          "hover:bg-background-light": "#EEF2F7",
        },
        {
          "hover:bg-surface-01": "#f4f4f4",
        },
        {
          "hover:bg-surface-02": "#F2F2F2",
        },
        {
          "hover:bg-surface-03": "#f4f4f5",
        },
        {
          "hover:bg-border-color": "#EBECED",
        },
        {
          "hover:bg-text-secondary": "#9A9A9A",
        },
        {
          "hover:bg-text-muted": "#929292",
        },
        {
          "hover:bg-text-disabled": "#8B8A8B",
        },
        {
          "hover:bg-danger-light": {
            r: "155",
            g: "245",
            b: "35",
            a: "0.27",
          },
        },
        {
          "hover:bg-table-header-bg": "#0A192F",
        },
        {
          "hover:bg-table-header-text": "#ffffff",
        },
        {
          "hover:bg-table-body-bg": "#ffffff",
        },
      ],
    },
    border: {
      normal: [
        {
          "border-primary": "#CA4D55",
        },
        {
          "border-secondary": "#0A192F",
        },
        {
          "border-sidebar": "#172933",
        },
        {
          "border-background-light": "#EEF2F7",
        },
        {
          "border-surface-01": "#f4f4f4",
        },
        {
          "border-surface-02": "#F2F2F2",
        },
        {
          "border-surface-03": "#F6F6F6",
        },
        {
          "border-border-color": "#EBECED",
        },
        {
          "border-text-secondary": "#9A9A9A",
        },
        {
          "border-text-muted": "#929292",
        },
        {
          "border-text-disabled": "#8B8A8B",
        },
        {
          "border-danger-light": "#fee2e2",
        },
        {
          "border-table-header-bg": "#0A192F",
        },
        {
          "border-table-header-text": "#ffffff",
        },
        {
          "border-table-body-bg": "#ffffff",
        },
      ],
      hover: [
        {
          "hover:border-primary": "#CA4D55",
        },
        {
          "hover:border-secondary": "#0A192F",
        },
        {
          "hover:border-sidebar": "#172933",
        },
        {
          "hover:border-background-light": "#EEF2F7",
        },
        {
          "hover:border-surface-01": "#f4f4f4",
        },
        {
          "hover:border-surface-02": "#F2F2F2",
        },
        {
          "hover:border-surface-03": "#F6F6F6",
        },
        {
          "hover:border-border-color": "#EBECED",
        },
        {
          "hover:border-text-secondary": "#9A9A9A",
        },
        {
          "hover:border-text-muted": "#929292",
        },
        {
          "hover:border-text-disabled": "#8B8A8B",
        },
        {
          "hover:border-danger-light": "#fee2e2",
        },
        {
          "hover:border-table-header-bg": "#0A192F",
        },
        {
          "hover:border-table-header-text": "#ffffff",
        },
        {
          "hover:border-table-body-bg": "#ffffff",
        },
      ],
    },
    text: {
      normal: [
        {
          "text-primary": {
            r: "224",
            g: "208",
            b: "25",
            a: "1",
          },
        },
        {
          "text-secondary": "#0A192F",
        },
        {
          "text-sidebar": "#172933",
        },
        {
          "text-background-light": "#EEF2F7",
        },
        {
          "text-surface-01": "#f4f4f4",
        },
        {
          "text-surface-02": "#F2F2F2",
        },
        {
          "text-surface-03": "#F6F6F6",
        },
        {
          "text-border-color": "#EBECED",
        },
        {
          "text-text-secondary": "#9A9A9A",
        },
        {
          "text-text-muted": "#929292",
        },
        {
          "text-text-disabled": "#8B8A8B",
        },
        {
          "text-danger-light": "#fee2e2",
        },
        {
          "text-table-header-bg": "#0A192F",
        },
        {
          "text-table-header-text": "#ffffff",
        },
        {
          "text-table-body-bg": "#ffffff",
        },
      ],
      hover: [
        {
          "hover:text-primary": {
            r: "224",
            g: "208",
            b: "25",
            a: "1",
          },
        },
        {
          "hover:text-secondary": "#0A192F",
        },
        {
          "hover:text-sidebar": "#172933",
        },
        {
          "hover:text-background-light": "#EEF2F7",
        },
        {
          "hover:text-surface-01": "#f4f4f4",
        },
        {
          "hover:text-surface-02": "#F2F2F2",
        },
        {
          "hover:text-surface-03": "#F6F6F6",
        },
        {
          "hover:text-border-color": "#EBECED",
        },
        {
          "hover:text-text-secondary": "#9A9A9A",
        },
        {
          "hover:text-text-muted": "#929292",
        },
        {
          "hover:text-text-disabled": "#8B8A8B",
        },
        {
          "hover:text-danger-light": "#fee2e2",
        },
        {
          "hover:text-table-header-bg": "#0A192F",
        },
        {
          "hover:text-table-header-text": "#ffffff",
        },
        {
          "hover:text-table-body-bg": "#ffffff",
        },
      ],
    },
  },
  selectedTheme: "banana",
};

const themes = [{ name: "Banana", value: "banana", data: banana }];

export default themes;
